import React from "react";
import Sidebar from "./components/Sidebar/Sidebar";
import PedidosNoPreparados from "./components/PedidosNoPreparados/PedidosNoPreparados";

function App() {
    return (
        <div style={{ display: "flex", height: "100vh" }}>
            <Sidebar />
            <div style={{ flex: 1, overflowY: "auto", backgroundColor: "#f5f5f5", padding: "20px" }}>
                <PedidosNoPreparados />
            </div>
        </div>
    );
}

export default App;